import Immutable from 'immutable';
import {
  FLAG_GETTING_BASE_PRICES_PER_KILOMETER,
  GET_BASE_PRICES_PER_KILOMETER,
  CLEAR_BASE_PRICES_PER_KILOMETER,
  FLAG_BASE_PRICE_PER_KILOMETER_ACTIVITY,
  CLEAR_BASE_PRICE_PER_KILOMETER,
  GET_BASE_PRICE_PER_KILOMETER,
} from '../../../actions/types/cargo';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_BASE_PRICES_PER_KILOMETER:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_BASE_PRICES_PER_KILOMETER:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_BASE_PRICES_PER_KILOMETER:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BASE_PRICE_PER_KILOMETER_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BASE_PRICE_PER_KILOMETER:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_BASE_PRICE_PER_KILOMETER:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
